import { SEO } from '@/components/common/SEO';
import { Hero } from '@/components/common/Hero';
import { Card } from '@/components/ui/Card';
import { PageLoader } from '@/components/ui/Spinner';
import { usePage } from '@/hooks/usePages';
import { useTranslation } from '@/features/i18n';

export function PrivacyPolicyPage() {
  const { data: page, isLoading } = usePage('privacy-policy');
  const { t } = useTranslation();

  if (isLoading) {
    return <PageLoader />;
  }

  return (
    <>
      <SEO
        title={page?.seo_title || t.legal.privacy.title}
        description={page?.seo_description || t.legal.privacy.seoDescription}
      />

      <Hero
        title={page?.title || t.legal.privacy.title}
        subtitle={page?.subtitle || t.legal.privacy.lastUpdated}
        size="sm"
      />

      <section className="py-16 lg:py-24 bg-white dark:bg-neutral-900">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          <Card padding="lg">
            {page?.content_json ? (
              <div className="prose prose-lg dark:prose-invert max-w-none">
                {page.content_json.map((block, index) => (
                  <div
                    key={index}
                    dangerouslySetInnerHTML={{ __html: block.content }}
                  />
                ))}
              </div>
            ) : (
              <div className="prose prose-lg dark:prose-invert max-w-none">
                <h2>1. Innledning</h2>
                <p>
                  Dina i Bedrift AS ("vi", "oss", "vår") er behandlingsansvarlig for
                  personopplysninger som samles inn gjennom våre nettsider og tjenester. Vi er
                  forpliktet til å beskytte ditt personvern i samsvar med personopplysningsloven
                  og GDPR.
                </p>

                <h2>2. Hvilke opplysninger samler vi inn</h2>
                <p>Vi samler inn følgende typer personopplysninger:</p>
                <ul>
                  <li>Kontaktinformasjon (navn, e-post, telefonnummer)</li>
                  <li>Bedriftsinformasjon</li>
                  <li>Teknisk informasjon (IP-adresse, nettlesertype)</li>
                  <li>Kommunikasjonsdata fra henvendelser</li>
                </ul>

                <h2>3. Hvordan bruker vi opplysningene</h2>
                <p>Vi bruker personopplysningene til:</p>
                <ul>
                  <li>Levere og forbedre våre tjenester</li>
                  <li>Kommunisere med deg om våre tjenester</li>
                  <li>Sende relevant markedsføring (med ditt samtykke)</li>
                  <li>Overholde juridiske forpliktelser</li>
                </ul>

                <h2>4. Dine rettigheter</h2>
                <p>Du har rett til:</p>
                <ul>
                  <li>Innsyn i dine personopplysninger</li>
                  <li>Retting av unøyaktige opplysninger</li>
                  <li>Sletting av opplysninger</li>
                  <li>Begrensning av behandling</li>
                  <li>Dataportabilitet</li>
                  <li>Å protestere mot behandling</li>
                </ul>

                <h2>5. Kontakt oss</h2>
                <p>For spørsmål om personvern, kontakt oss på:</p>
                <p>
                  E-post: personvern@dinaibedrift.no
                  <br />
                  Telefon: +47 123 45 678
                </p>
              </div>
            )}
          </Card>
        </div>
      </section>
    </>
  );
}
